import React from "react";

type SvgProps = React.SVGProps<SVGSVGElement>;

export const Document = (props: SvgProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8049_5002)">
      <path
        d="M9.914 1.70676L8.793 0.585763C8.60768 0.399417 8.38724 0.251675 8.14444 0.151089C7.90164 0.0505023 7.64131 -0.000931975 7.3785 -0.000237195H3C2.60218 -0.000237195 2.22064 0.157798 1.93934 0.439103C1.65804 0.720407 1.5 1.10194 1.5 1.49976V11.9998H10.5V3.12076C10.4987 2.59061 10.2881 2.08243 9.914 1.70676V1.70676ZM9.207 2.41376C9.23214 2.44105 9.25568 2.46976 9.2775 2.49976H8V1.22226C8.03 1.24408 8.05872 1.26762 8.086 1.29276L9.207 2.41376ZM2.5 10.9998V1.49976C2.5 1.36715 2.55268 1.23998 2.64645 1.14621C2.74021 1.05244 2.86739 0.999763 3 0.999763H7V3.49976H9.5V10.9998H2.5ZM3.5 7.99976H8.5V4.99976H3.5V7.99976ZM4.5 5.99976H7.5V6.99976H4.5V5.99976ZM3.5 8.99976H8.5V9.99976H3.5V8.99976Z"
        fill="#481DD6"
      />
    </g>
    <defs>
      <clipPath id="clip0_8049_5002">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
